import React from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Fab } from "@material-ui/core";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import { useStaticQuery, graphql } from "gatsby";
import { _ } from "../utils/i18n";

import Button from "../components/button";
import CloseIcon from "@material-ui/icons/Close";
import List from "../components/list";
import ListItems from "../components/list-items";
import ImageLibpixel from "./image-libpixel.js";

// css
import "./animate.css";

const FabButton = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    color: "#FFF",
    boxShadow: "none",
    fontSize: 18,
    margin: "0 8px 0 5px",
    width: 36,
    height: 30,
    "&:focus": {
      boxShadow: "none",
    },
    [theme.breakpoints.down(811)]: {
      backgroundColor: "transparent",
      "&:hover ": {
        backgroundColor: "transparent",
      },
    },
  },
  label: {
    fontSize: 20,
  },
}))(Fab);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    width: "calc(100% / 3 - (40px / 3))",
    position: "relative",
  },
  buttonStyle: {
    color: theme.palette.primary.main,
  },
  children: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    marginTop: 20,
  },
  wrapper: {
    width: 364,
    height: 580,
    borderRadius: 20,
    backgroundColor: "#F8F8F8",
    transition: "all .2s ease",
    margin: "0 12px 20px 12px",
    "&:hover": {
      backgroundColor: theme.palette.common.white,
      boxShadow: "0 0 20px rgba(0, 0, 0, 0.16)",
    },
    [theme.breakpoints.down("md")]: {
      "& span": {
        display: "block",
      },
    },
    "&:hover span": {
      display: "block",
    },
  },
  img: {
    width: 364,
    height: 364,
    objectFit: "cover",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    cursor: "pointer",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  textBox: {
    marginLeft: 15,
    marginBottom: 20,
  },
  title: {
    marginBottom: 5,
  },
  subtitle: {
    fontSize: "0.8rem",
    marginBottom: 0,
    color: "#6F6F6F",
  },
  contactBox: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    position: "relative",
  },
  contactInfoBox: {
    width: "70%",
    flexDirection: "column",
    display: "flex",
  },
  contactInfo: {
    margin: "10px 15px 5px 0",
    fontSize: "0.8rem",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  arrow: {
    marginTop: 20,
    paddingRight: 10,
    display: "none",
  },
  link: {
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));
function hasValue(v) {
  return v && v && v !== "null" && v !== null ? true : false;
}
export default function EmployeeCard(props) {
  const { tjen, kval, rest } = useStaticQuery(
    graphql`
      query {
        tjen: allWpCategory(
          filter: {
            wpParent: {
              node: { databaseId: { ne: 29 }, parentDatabaseId: { ne: 29 } }
            }
            databaseId: { ne: 29 }
          }
        ) {
          edges {
            node {
              slug
              uri
              name
              description
              databaseId
              parentDatabaseId
            }
          }
        }
        rest: allWpCategory(
          filter: { wpParent: { node: { parentDatabaseId: { eq: 29 } } } }
        ) {
          edges {
            node {
              slug
              uri
              name
              description
              databaseId
              parentDatabaseId
            }
          }
        }
        kval: allWpCategory(
          filter: { wpParent: { node: { databaseId: { eq: 29 } } } }
        ) {
          edges {
            node {
              slug
              uri
              name
              description
              databaseId
              parentDatabaseId
            }
          }
        }
      }
    `
  );

  const classes = useStyles();
  const activeStyle = {
    backgroundColor: "#FFFFFF",
    boxShadow: "0 0 20px rgba(0, 0, 0, 0.16)",
  };
  const inactiveStyle = {
    //do nothing
  };
  const [open, setOpen] = React.useState(false);
  const [current, setCurrent] = React.useState(false);
  const [isCurrent, checkCurrent] = React.useState(false);

  const handleClick = () => {
    setOpen((prev) => !prev);
    setCurrent((current) => !current);
  };
  const handleClickAway = () => {
    if (window.innerWidth > 1024) {
      setOpen(false);
      setCurrent(false);
    }
  };

  React.useEffect(() => {
    if (isCurrent) {
      var cur = document.getElementById("current");
      if (cur) {
        cur.setAttribute("id", "");
      }
    }
  }, [isCurrent]);

  var cats = [];

  props.cat?.forEach((c) => cats.push(c.databaseId));

  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={handleClickAway}
    >
      <div
        id={current ? "current" : ""}
        className={`wrapper ansatteCard ${classes.wrapper}`}
        style={open ? activeStyle : inactiveStyle}
      >
        <ImageLibpixel
          src={props.img}
          alt={_("Ansatte")}
          className={classes.img}
          onClick={handleClick}
        />
        <div className={classes.textBox}>
          <h3 className={classes.title}>{props.name && props.name}</h3>
          <p className={classes.subtitle}>{props.jobTitle && props.jobTitle}</p>
          <div className={classes.contactBox}>
            <div className={classes.contactInfoBox}>
              <a
                href={`tel: ${
                  props.tel && props.tel.replace(/ /g, "").replace("+", "00")
                }`}
                className={classes.contactInfo}
              >
                {hasValue(props.tel) && props.tel}
              </a>
              <a href={`mailto:${props.email}`} className={classes.contactInfo}>
                {hasValue(props.email) && props.email}
              </a>
            </div>
            <span
              className={` arrow-up-close ${classes.arrow}`}
              onClick={handleClick}
            >
              <FabButton className="animated bounce">
                <ArrowRightAltIcon
                  style={{
                    transform: "rotate(90deg)",
                    width: 30,
                    height: 30,
                    position: "absolute",
                    top: "2px",
                    right: "3px",
                  }}
                />
              </FabButton>
            </span>
          </div>
        </div>
        <div className="hideorseek">
          <div
            className="contact-expandbox"
            style={{
              position: "absolute",
              background: "#fff",
              right: "0",
              left: "0",
              width: "auto",
              marginTop: "70px",
              height: "auto",
            }}
          >
            <div className="expandbox-left">
              <h2 className="expandbox-name">{props.name && props.name}</h2>
              <p className="expandbox-jobtitle">
                {props.jobTitle && props.jobTitle}
              </p>
              <div
                className="expandbox-ingress"
                dangerouslySetInnerHTML={{
                  __html: props.content && props.content,
                }}
              />
              <div style={{ display: "flex" }}>
                <Button
                  variant="primary"
                  label={_("Ring meg")}
                  url={`tel: ${
                    hasValue(props.tel) &&
                    props.tel.replace(/ /g, "").replace("+", "00")
                  }`}
                />
                <Button
                  variant="primary"
                  label={_("Send meg en epost")}
                  url={`mailto:${props.email}`}
                />
              </div>
            </div>
            <div
              className="expandbox-right"
              style={{ flexDirection: "column", flexWrap: "nowrap" }}
            >
              <div
                className="expandbox-closebtn"
                onClick={() => checkCurrent((isCurrent) => !isCurrent)}
              >
                <CloseIcon style={{ cursor: "pointer" }} />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "40px",
                  justifyContent: "flex-end",
                }}
              >
                <div className="expandbox-right-list">
                  <p className="expandbox-title">{_("Mine tjenester")}:</p>
                  {tjen &&
                    tjen.edges
                      .filter(({ node }) => cats.indexOf(node.databaseId) > -1)
                      .map((t) => (
                        <>
                          <List title={t.node.name.replace("&amp;", "&")} />
                        </>
                      ))}
                </div>
                <div className="expandbox-right-list">
                  {kval &&
                    kval.edges.filter(
                      ({ node }) => cats.indexOf(node.databaseId) > -1
                    ).length > 0 && (
                      <p className="expandbox-title">
                        {_("Mine kvalifikasjoner")}:
                      </p>
                    )}
                  {kval &&
                    kval.edges
                      .filter(({ node }) => cats.indexOf(node.databaseId) > -1)
                      .map((t, i) => (
                        <List key={i} canExpand title={t.node.name}>
                          {rest &&
                            rest.edges
                              .filter(
                                ({ node }) => cats.indexOf(node.databaseId) > -1
                              )
                              .filter(
                                ({ node }) =>
                                  node.parentDatabaseId.toString() ===
                                  t.node.databaseId.toString()
                              )
                              .map((c, j) => (
                                <ListItems
                                  key={j}
                                  text={c.node.name.replace("&amp;", "&")}
                                />
                              ))}
                        </List>
                      ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ClickAwayListener>
  );
}

EmployeeCard.propTypes = {
  img: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired,
  tel: PropTypes.string,
  email: PropTypes.string,
  content: PropTypes.string,
  cat: PropTypes.array,
};

EmployeeCard.defaultProps = {
  tel: "",
  email: "",
  content: "",
  cat: undefined,
};
